import { DocumentIcon, Pencil } from "assets/icons";
import BadgeSquare from "components/badge/badgeSquare";

const Confirmationupdate = ({
  setFormIndex,
  userData,
  nationality,
  forceNationality,
}) => {
  // Check if visa is required (non-EU nationality or existing visa)
  const hasVisa = userData?.visa?.validated === "1" ||
    userData?.visa?.validated === "2" ||
    userData?.visa?.validated === "3" ||
    nationality === "NUE" ||
    forceNationality === "NUE";

  const handleModifyIdentityGroup = (e) => {
    e.preventDefault();
    // Redirect to identity upload page (all documents in identity group are modified together)
    setFormIndex(2);
  };

  // Determine badge to display (priority to lowest/non-validated status)
  const getCombinedBadge = () => {
    const identityStatus = userData?.identity?.validated;
    const selfieStatus = userData?.selfie?.validated;
    const visaStatus = hasVisa ? userData?.visa?.validated : null;
    
    // If any is not submitted (0), show that status
    if (identityStatus === "0" || selfieStatus === "0" || (hasVisa && visaStatus === "0")) return "0";
    // If any is refused (3), show that status
    if (identityStatus === "3" || selfieStatus === "3" || (hasVisa && visaStatus === "3")) return "3";
    // If any is pending (1), show that status
    if (identityStatus === "1" || selfieStatus === "1" || (hasVisa && visaStatus === "1")) return "1";
    // Otherwise, show validated status
    return identityStatus || selfieStatus || visaStatus;
  };

  // Get label based on whether visa is included
  const getDocumentLabel = () => {
    if (hasVisa) {
      return "Pièce d'identité & Selfie & Visa";
    }
    return "Pièce d'identité & Selfie";
  };

  return (
    <div className={"flex flex-col gap-4"}>
      <div className="flex items-center justify-between">
        <div className="flex gap-2">
          <div className="relative my-auto bg-gray-100 w-[40px] h-[40px] flex justify-center items-center rounded-full">
            <DocumentIcon wh={35} color={"#111827"} />
          </div>
          <div className="col-span-3 ft-b text-gray-900 my-auto">
            <div className={`text-gray-900`}>{getDocumentLabel()}</div>
          </div>
        </div>
        <div className="col-span-1 flex">
          <div className="my-auto mr-2">
            <BadgeSquare type={getCombinedBadge()} />
          </div>
          <div className="my-auto">
            <button
              onClick={handleModifyIdentityGroup}
              className="rounded-full w-10 h-10 flex items-center justify-center"
            >
              <Pencil wh={22} color={"#374151"} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Confirmationupdate;
